module.exports = __webpack_public_path__ + "img/logo.785dd1f3.png";